// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_Xjn","cls2":"CiterightPreprintReport-cls2_w6E CiterightPreprintReport-cls1_Xjn"};